import config from "../../../config/common";
import { request } from "../";
import { SERVICE_BANNER_REQUEST } from "../constants";
import { isTestEndpoint } from "../../../state/modules/config/selectors";
import getServiceBannerApiBaseUrl from "./getServiceBannerApiBaseUrl";

const {
  api: {
    serviceBanner: { timeout },
  },
} = config;

const requestTimeout = parseInt(timeout, 10);

export const getServiceBanner = ({
  country: {
    defaultLanguage: language,
    countryCode: country,
    storeCode: store,
  },
  uuid,
  xSiteOrigin,
}) => {
  const baseUrl = getServiceBannerApiBaseUrl();

  const params = {
    shop: "asos",
    language,
    banner: "PLP Banner",
    country,
    store,
  };

  if (isTestEndpoint(baseUrl)) {
    params["x-site-origin"] = xSiteOrigin;
  }

  const queryString = new URLSearchParams(params).toString();
  const url = `${baseUrl}?${queryString}`;

  return request(
    url,
    { timeout: requestTimeout },
    SERVICE_BANNER_REQUEST,
    uuid,
  );
};
